import { OpenInNew } from '@mui/icons-material';
import ThemeTokenContextProvider from '@providers/themeTokenProvider';
import type { Meta, StoryFn } from '@storybook/react-vite';
import { Button as ButtonComponent } from './button';

export default {
  title: '2-component/Button',
  component: ButtonComponent,
} as Meta<typeof ButtonComponent>;

const Template: StoryFn<typeof ButtonComponent> = (args: any) => (
  <ThemeTokenContextProvider>
    <ButtonComponent {...args} />
  </ThemeTokenContextProvider>
);

export const Button = Template.bind({});
Button.args = {
  variant: 'filled',
  label: 'Button',
};

export const LeadingIcon = Template.bind({});
LeadingIcon.args = {
  variant: 'filled',
  label: 'Button',
  leadingIcon: OpenInNew,
};

export const TrailingIcon = Template.bind({});
TrailingIcon.args = {
  variant: 'filled',
  label: 'Button',
  trailingIcon: OpenInNew,
};
